// extracted by mini-css-extract-plugin
export default {"wrapper":"BookService_wrapper__y+9Yn","Service":"BookService_Service__-+XXP","item-wp":"BookService_item-wp__HbKZh"};